import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.writingFrequency.relationships',
    subtitle: 'pages.onboarding.writingFrequency.relationshipsSub',
    value: 'relationships',
  },
  {
    title: 'pages.onboarding.writingFrequency.domainJudgment',
    subtitle: 'pages.onboarding.writingFrequency.domainJudgmentSub',
    value: 'domain-judgment',
  },
  {
    title: 'pages.onboarding.writingFrequency.crossFunctional',
    subtitle: 'pages.onboarding.writingFrequency.crossFunctionalSub',
    value: 'cross-functional',
  },
  {
    title: 'pages.onboarding.writingFrequency.creativeStrategic',
    subtitle: 'pages.onboarding.writingFrequency.creativeStrategicSub',
    value: 'creative-strategic',
  },
  {
    title: 'pages.onboarding.writingFrequency.institutional',
    subtitle: 'pages.onboarding.writingFrequency.institutionalSub',
    value: 'institutional',
  },
  {
    title: 'pages.onboarding.writingFrequency.leadership',
    subtitle: 'pages.onboarding.writingFrequency.leadershipSub',
    value: 'leadership',
  },
]

export default function WritingFrequencyPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      multiple
      title="pages.onboarding.writingFrequency.title"
      subtitle="pages.onboarding.writingFrequency.subtitle"
    />
  )
}
